import * as t from 'io-ts';
import { BaseNotificationC } from './Notification';
import { NotificationTypeC } from './NotificationType';

export const NotificationSocketMessageC = t.intersection([
    BaseNotificationC,
    t.type({
        type: NotificationTypeC,
    }),
]);

export type NotificationSocketMessage = t.TypeOf<typeof NotificationSocketMessageC>;
